import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Radio, RadioGroup, FormControlLabel } from '@mui/material';
import { X } from '@phosphor-icons/react';

// Images
import defaultImg from '../../adminAssets/images/templates/preview/default.png';
import whiteImg from '../../adminAssets/images/templates/preview/white.png';
import redImg from '../../adminAssets/images/templates/preview/red.png';
import blueImg from '../../adminAssets/images/templates/preview/blue.png';
import greenImg from '../../adminAssets/images/templates/preview/green.png';
import orangeImg from '../../adminAssets/images/templates/preview/orange.png';

const themes = [
    { id: 'default', name: 'Default', img: defaultImg },
    { id: 'white', name: 'White', img: whiteImg },
    { id: 'red', name: 'Red', img: redImg },
    { id: 'blue', name: 'Blue', img: blueImg },
    { id: 'green', name: 'Green', img: greenImg },
    { id: 'orange', name: 'Orange', img: orangeImg }
];

const ThemeSelectionModal = ({ open, onClose, onThemeChange }) => {
    const [selectedTheme, setSelectedTheme] = useState('default');

    useEffect(() => {
        const savedTheme = localStorage.getItem('website_theme');
        if (savedTheme) {
            setSelectedTheme(savedTheme);
        }
    }, [open]);

    const handleThemeChange = (event) => {
        const themeId = event.target.value;
        setSelectedTheme(themeId);
        localStorage.setItem('website_theme', themeId);
        
        if (onThemeChange) {
            onThemeChange(themeId);
        }
    };

    return (
        <Dialog 
            open={open} 
            onClose={onClose} 
            maxWidth="lg" 
            fullWidth
            PaperProps={{
                style: { borderRadius: '16px', padding: '16px' }
            }}
        >
            <DialogTitle className="d-flex justify-content-between align-items-center border-0 pb-0">
                <div>
                    <h5 className="mb-2 fw-bold text-dark" style={{ fontSize: '20px' }}>Website Color Template</h5>
                    <p className="text-14 text-gray-500 mb-0 fw-normal">Pilih warna template website toko kamu</p>
                </div>
                <IconButton onClick={onClose} className="align-self-start">
                    <X size={24} />
                </IconButton>
            </DialogTitle>
            <DialogContent className="border-0 pt-4 pb-2 overflow-hidden">
                <RadioGroup value={selectedTheme} onChange={handleThemeChange}>
                    <div className="row g-4 justify-content-center">
                        {themes.map((theme) => (
                            <div key={theme.id} className="col-12 col-sm-6 col-md-4 col-lg-2">
                                <div className="d-flex flex-column align-items-center">
                                    <div 
                                        className="rounded-3 overflow-hidden mb-3 w-100"
                                        style={{ 
                                            cursor: 'pointer', 
                                            border: selectedTheme === theme.id ? '2px solid #2563EB' : '1px solid #e5e5e5',
                                            boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                                            transition: 'all 0.2s ease-in-out'
                                        }}
                                        onClick={() => handleThemeChange({ target: { value: theme.id } })}
                                    >
                                        <img src={theme.img} alt={theme.name} className="w-100 h-auto" />
                                    </div>
                                    <FormControlLabel 
                                        value={theme.id} 
                                        control={
                                            <Radio 
                                                sx={{ 
                                                    '&.Mui-checked': { color: '#dc3545' },
                                                    '& .MuiSvgIcon-root': { fontSize: 24 } 
                                                }} 
                                            />
                                        } 
                                        label={<span className="text-14 fw-medium text-dark">{theme.name}</span>}
                                        className="m-0"
                                        sx={{ marginRight: 0 }}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </RadioGroup>
            </DialogContent>
        </Dialog>
    );
};

export default ThemeSelectionModal;
